export default {
  // Nombre del modulo
  tasks: 'Tareas',
  task: 'Tarea',
  no_tasks_created: 'No se creó ninguna tarea: los usuarios elegidos no tienen ese rol en las ubicaciones seleccionadas',
  // Niveles de prioridad de tarea
  priority: {
    low: 'Baja',
    medium: 'Media',
    high: 'Alta'
  }
}
